import { PromoContent } from '@cinemark/content-api-client';
import { PromotionalImage } from './promotional-image';
import { PromotionalText } from './promotional-text/promotional-text';

type PromotionalImageWithTextProps = {
  dataLinkCategory: string;
  dataLinkName?: string;
  promoContent: PromoContent;
};

export const PromotionalImageWithText = ({ dataLinkCategory, dataLinkName, promoContent }: PromotionalImageWithTextProps): React.JSX.Element | null => {
  if (!promoContent) {
    return null;
  }

  return (
    <div>
      <PromotionalImage className="rounded-b-none"
        dataLinkCategory={dataLinkCategory}
        dataLinkName={dataLinkName}
        promoContent={promoContent}
      />
      <PromotionalText className="rounded-t-none"
        dataLinkCategory={dataLinkCategory}
        dataLinkName={dataLinkName}
        promoContent={promoContent}
      />
    </div>
  );
};
